import { FC } from "react"
import Form from "./Form"
import Info, { InfoProps } from "./Info"
import DualPanelModal from "@/components/DualPanelModal"
import { ColorVariant } from "@/types/index"
import { capitalizeFirstLetter } from "@/utils/index"
import "./index.scss"

interface DeleteConfirmationModalProps {
   kind: string
   text?: string
   isSuccess: boolean
   loading: boolean
   icon?: InfoProps["icon"]
   description?: string
   successDescription?: string
   instruction?: string
   handleSave: () => void
   handleCloseModal: () => void
}

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
   kind,
   text,
   isSuccess,
   loading,
   icon,
   description,
   successDescription,
   instruction,
   handleSave,
   handleCloseModal,
}) => {
   const getInfoProps = (): InfoProps => {
      if (isSuccess) {
         return {
            headerText: `${capitalizeFirstLetter(kind)} deleted`,
            contentText:
               successDescription ??
               `All information related to the ${kind} has been removed from the system.`,
         }
      }

      return {
         icon,
         headerText: `Delete ${kind}`,
         contentText:
            description ??
            `Are you sure you wish to delete all information related to ${kind}:`,
         itemName: text,
      }
   }

   return (
      <DualPanelModal
         open
         centered
         variant={ColorVariant.COOL_GRAY}
         onClose={handleCloseModal}
         infoSection={<Info {...getInfoProps()} />}
         actionSection={
            <Form
               loading={loading}
               kind={kind}
               isSuccess={isSuccess}
               text={text}
               instruction={instruction}
               onSave={isSuccess ? handleCloseModal : handleSave}
            />
         }
      />
   )
}

export default DeleteConfirmationModal
